import { CSSProperties, FC, useEffect, useState } from 'react';

interface ModalProps {
  isOpen?: boolean;
  onClose: () => void;
  children?: React.ReactNode;
}

export const MobileModal: FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const [isClosing, setClosing] = useState(false);

  const [modalStyle, setModalStyle] = useState({
    position: 'fixed',
    inset: 0,
    justifyContent: 'center',
    alignItems: 'flex-end',
    zIndex: 100000,
    display: 'flex',
    transform: 'translateY(100%)',
    transition: 'transform 0.5s ease-out',
  });
  const [backdropStyle, setBackdropStyle] = useState({
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'block',
    zIndex: 99999,
    opacity: 0,
    transition: 'opacity 0.5s ease-out',
  });

  useEffect(() => {
    if (isOpen) {
      requestAnimationFrame(() => {
        setModalStyle((prevStyle) => ({ ...prevStyle, transform: 'translateY(0)' }));
        setBackdropStyle((prevStyle) => ({ ...prevStyle, opacity: 1 }));
      });
    }
  }, [isOpen]);

  const handleClose = () => {
    setClosing(true);
    setModalStyle((prevStyle) => ({ ...prevStyle, transform: 'translateY(100%)' }));
    setBackdropStyle((prevStyle) => ({ ...prevStyle, opacity: 0 }));
    setTimeout(() => {
      onClose();
      setClosing(false);
    }, 500);
  };

  if (!isOpen && !isClosing) return null;

  return (
    <>
      <div style={backdropStyle as CSSProperties} onClick={handleClose} />
      <div style={modalStyle as CSSProperties} onClick={handleClose}>
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            backgroundColor: 'white',
            overflowY: 'auto',
            maxHeight: '90%',
            width: '100%',
            padding: 0,
            margin: 0,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
};
